import TOP_BARS from '@topBars';
let routes = [
  /**
   * @description deans-list入口
   * @function /deans-list
   * @param {Component} DeansList /views/DeansList
   * @param {Name} pathname DeansList
   */
  {
    path: '/deans-list',
    name: 'deans-list',
    meta: {
      title: "Dean's List"
    },
    component: () => import('@/views/DeansList')
  },
  {
    path: '/deans-list/passport',
    name: 'deans-list-passport',
    meta: {
      title: "Dean's List"
    },
    component: () => import('@/views/DeansList/Passport')
  },
  {
    path: '/deans-list/visa',
    name: 'deans-list-visa',
    meta: {
      title: "Dean's List"
    },
    component: () => import('@/views/DeansList/Visa')
  },
  {
    path: '/deans-list/final-payment',
    name: 'deans-list-final-payment',
    meta: {
      title: "Dean's List"
    },
    component: () => import('@/views/DeansList/BalancePayment')
  },
  {
    path: '/deans-list/courses',
    name: 'deans-list-courses',
    meta: {
      title: "Dean's List"
    },
    component: () => import('@/views/DeansList/Courses')
  }
];
routes = routes.map(item => {
  let ret = { ...item };
  ret.meta = {
    topBar: TOP_BARS.DEFAULT,
    ...ret.meta
  };
  return ret;
});
export default routes;
